import { useState } from "react";
import styles from "./FAQSection.module.css";

const faqs = [
  {
    question: "Can AI parse all types of resumes?",
    answer: "Yes, ToxBox AI supports PDF, DOCX, and TXT formats.",
  },
  {
    question: "How does AI rank candidates?",
    answer: "Based on skills, experience, and role suitability.",
  },
  {
    question: "Does it integrate with ATS?",
    answer: "Yes, ToxBox AI connects with most major HR platforms.",
  },
  {
    question: "Is candidate data secure?",
    answer:
      "Absolutely. Data is encrypted and compliant with global standards.",
  },
  {
    question: "Can it reduce hiring bias?",
    answer:
      "Absolutely. Data is encrypted and compliant with global standards.",
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className={styles.faqSection}>
      <h2 className={styles.heading}>
        Frequently Asked Questions About <br /> AI Resume Screening
      </h2>

      <div className={styles.faqList}>
        {faqs.map((faq, index) => (
          <div key={index} className={styles.faqItem}>
            <div
              className={styles.faqQuestion}
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span className={styles.icon}>
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <p className={styles.faqAnswer}>{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
